//Portfolio
//
//Site Details
//Site Slicer
//Date Slicer
//Heatmap
//Site Slicer
//Date Slicer
import constants from '../constants';

const setSlicers = async function (
    reportParameters,
    visuals,
    loadFirst = true
  ) {
    if (loadFirst) {
      await setSiteSlicerVisual(reportParameters, visuals);
    }
    await setDateSlicerVisual(reportParameters, visuals);
  },
  setSiteSlicerVisual = async function (reportParameters, visuals) {
    const siteSlicerFilter = {
      $schema: constants.ADVANCED_FILTER,
      target: {
        table: 'vwSite',
        column: 'SiteName',
      },
      operator: 'In',
      values: [reportParameters.SiteName],
    };

    const siteSlicerVisual = visuals.filter(function (visual) {
      return visual.type === 'slicer' && visual.title === 'Site Slicer';
    })[0];

    if (siteSlicerVisual) {
      // Set the slicer state which contains the slicer filters.
      await siteSlicerVisual.setSlicerState({
        filters: [siteSlicerFilter],
      });
    }
  },
  setDateSlicerVisual = async function (reportParameters, visuals) {
    const dateSlicerFilter = {
      $schema: constants.ADVANCED_FILTER,
      target: {
        table: 'vwReportingDateTime',
        column: 'Date',
      },
      logicalOperator: 'And',
      conditions: [
        {
          operator: 'GreaterThanOrEqual',
          value: reportParameters.StartDate,
        },
        {
          operator: 'LessThanOrEqual',
          value: reportParameters.EndDate,
        },
      ],
    };

    const dateSlicerVisual = visuals.filter(function (visual) {
      return visual.type === 'slicer' && visual.title === 'Date Slicer';
    })[0];

    if (dateSlicerVisual) {
      // Next lines will console the table and column from the slicer visual.
      // const state = await dateSlicerVisual.getSlicerState();
      // console.log('date state', state);
      await dateSlicerVisual.setSlicerState({
        filters: [dateSlicerFilter],
      });
    }
  };

export default {
  setSlicers,
};
